import React from "react";

import { BarAndPieChart } from "../../../Components/Charts/BarAndPieChart/BarAndPieChart";

interface LocalBarAndPieChartData {
  title: string;
  value: number;
}

interface ShoppingFunnelChartProps {
  data: any[];
}

export const transformShoppingFunnelData = (rawData: any[]): LocalBarAndPieChartData[] => {
  const fields = ["Show Inventory", "Unit Selected", "No Available Inventory", "Search Different Store"]; // need to add Length, Width, Features, and Rate

  const aggregatedData: { [key: string]: number } = {};

  rawData.forEach((item) => {
    fields.forEach((field) => {
      if (item[field]) {
        if (!aggregatedData[field]) {
          aggregatedData[field] = 0;
        }
        aggregatedData[field]++;
      }
    });
  });

  // Calculate "No Unit Selected"
  const showInventory = aggregatedData["Show Inventory"] || 0;
  const unitSelected = aggregatedData["Unit Selected"] || 0;
  const noAvailableInventory = aggregatedData["No Available Inventory"] || 0;
  const searchDifferentStore = aggregatedData["Search Different Store"] || 0;
  const noUnitSelected = showInventory - unitSelected - noAvailableInventory - searchDifferentStore;
  if (noUnitSelected >= 0) {
    aggregatedData["No Unit Selected"] = noUnitSelected;
  }

  // Exclude "Show Inventory" from the final chart
  delete aggregatedData["Show Inventory"];

  return Object.keys(aggregatedData).map((key) => ({
    title: key,
    value: aggregatedData[key]
  }));
};

export const ShoppingFunnelChart: React.FC<ShoppingFunnelChartProps> = ({ data }) => {
  const transformedData = transformShoppingFunnelData(data);
  return (
    <>
      <BarAndPieChart data={transformedData} showTotals={true} height={400} width={600} />
      <pre>{JSON.stringify(transformedData, null, 2)}</pre>
    </>
  );
};
